(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chickagu-office-new-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.newProductsReady === 'true') return;
      root.dataset.newProductsReady = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-category]'));
      const panels = Array.from(root.querySelectorAll('[data-category-panel]'));
      const previousButton = root.querySelector('[data-page-prev]');
      const nextButton = root.querySelector('[data-page-next]');
      const currentLabel = root.querySelector('[data-current-page-label]');
      const pageCountLabel = root.querySelector('[data-page-count-label]');
      const collectionLink = root.querySelector('[data-new-products-link]');
      const tabsScroller = root.querySelector('[data-tabs-scroll]');
      const tabsPreviousButton = root.querySelector('[data-tabs-previous]');
      const tabsNextButton = root.querySelector('[data-tabs-next]');

      if (!tabs.length || !panels.length) return;

      const activePanel = () => panels.find((panel) => panel.classList.contains('is-active'));

      const updateTabsArrows = () => {
        if (!tabsScroller || !tabsPreviousButton || !tabsNextButton) return;
        const maximumScroll = Math.max(0, tabsScroller.scrollWidth - tabsScroller.clientWidth);
        const hasOverflow = maximumScroll > 2;
        tabsPreviousButton.classList.toggle('is-hidden', !hasOverflow);
        tabsNextButton.classList.toggle('is-hidden', !hasOverflow);
        tabsPreviousButton.disabled = !hasOverflow || tabsScroller.scrollLeft <= 2;
        tabsNextButton.disabled = !hasOverflow || tabsScroller.scrollLeft >= maximumScroll - 2;
      };

      const scrollTabs = (direction) => {
        if (!tabsScroller) return;
        const distance = Math.max(160, Math.round(tabsScroller.clientWidth * 0.75));
        tabsScroller.scrollTo({
          left: tabsScroller.scrollLeft + direction * distance,
          behavior: 'smooth'
        });
      };

      const renderPage = (panel, requestedPage) => {
        if (!panel) return;
        const pageCount = Math.max(1, Number(panel.dataset.pageCount || 1));
        const page = Math.min(Math.max(0, requestedPage), pageCount - 1);
        panel.dataset.currentPage = String(page);
        panel.querySelectorAll('[data-new-product-card]').forEach((card) => {
          card.hidden = Number(card.dataset.page || 0) !== page;
        });
        if (currentLabel) currentLabel.textContent = String(page + 1);
        if (pageCountLabel) pageCountLabel.textContent = String(pageCount);
        if (previousButton) previousButton.disabled = page === 0;
        if (nextButton) nextButton.disabled = page >= pageCount - 1;
      };

      const activateCategory = (category) => {
        tabs.forEach((tab) => {
          const selected = tab.dataset.category === category;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && collectionLink && collectionLink.dataset.dynamicLink === 'true') {
            collectionLink.href = tab.dataset.collectionUrl || collectionLink.href;
          }
        });
        panels.forEach((panel) => {
          const selected = panel.dataset.categoryPanel === category;
          panel.classList.toggle('is-active', selected);
          panel.hidden = !selected;
          if (selected) renderPage(panel, 0);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateCategory(tab.dataset.category));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const target = tabs[(index + direction + tabs.length) % tabs.length];
          target.focus();
          activateCategory(target.dataset.category);
        });
      });

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          const panel = activePanel();
          renderPage(panel, Number(panel?.dataset.currentPage || 0) - 1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          const panel = activePanel();
          renderPage(panel, Number(panel?.dataset.currentPage || 0) + 1);
        });
      }

      if (tabsScroller) {
        tabsScroller.addEventListener('scroll', updateTabsArrows, { passive: true });
      }
      if (tabsPreviousButton) {
        tabsPreviousButton.addEventListener('click', () => scrollTabs(-1));
      }
      if (tabsNextButton) {
        tabsNextButton.addEventListener('click', () => scrollTabs(1));
      }
      if (tabsScroller && 'ResizeObserver' in window) {
        new ResizeObserver(updateTabsArrows).observe(tabsScroller);
      }

      renderPage(activePanel(), 0);
      requestAnimationFrame(updateTabsArrows);
    };

    document.querySelectorAll('[data-new-products]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-new-products]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
